import {RoomPlannerProduct} from 'components/customer/RoomPlanner/types';
import {get3dTemplate} from 'service/ProductService';
import {cloneDeep} from 'lodash';

export const mapTemplate = async (roomProduct: RoomPlannerProduct) => {
    const product = cloneDeep(roomProduct);

    // Preview payloads already include the 3D template — avoid the auth-only
    // quick-products fetch used in the editable room planner.
    if (product.template_3d?.length) {
        return product;
    }

    if (product?.type) {
        const template = await get3dTemplate(String(product.type));

        if (template) {
            product.template_3d = template;
        }
    }

    return product;
};
